import type { BreadcrumbItem } from 'pages/breadcrumbs'
import type { FC, ReactNode } from 'react'
import { Box, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material'
import BreadcrumbsConfig from 'pages/breadcrumbs'
import { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useBreadcrumbActions } from 'contexts/BreadcrumbActionsContext'

interface Props {
  maxItems?: number
  separator?: string
  actions?: ReactNode
}

const Breadcrumbs: FC<Props> = ({ maxItems = 8, separator = '/', actions }) => {
  const location = useLocation()
  const contextActions = useBreadcrumbActions()

  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const path = location.pathname
    for (const [configPath, breadcrumbs] of Object.entries(BreadcrumbsConfig)) {
      if (matchDynamicPath(path, configPath)) {
        return breadcrumbs
      }
    }
    console.warn('No matching breadcrumb configuration found for path:', path)
    return []
  }

  const matchDynamicPath = (currentPath: string, pathTemplate: string): boolean => {
    const regex = new RegExp(`^${pathTemplate.replace(/:\w+/g, '[\\w-]+')}$`)
    const isMatch = regex.test(currentPath)
    return isMatch
  }

  const breadcrumbs = getBreadcrumbs()
  const displayActions = actions || contextActions

  useEffect(() => {}, [breadcrumbs])

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <MuiBreadcrumbs aria-label="breadcrumb" maxItems={maxItems} separator={separator}>
        {breadcrumbs.map((item, index) => (
          <Typography
            key={index}
            component={item.url ? Link : 'span'}
            to={item.url}
            color={index === breadcrumbs.length - 1 ? 'textPrimary' : 'inherit'}
            variant="h6"
            sx={{
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              fontWeight: index === breadcrumbs.length - 1 ? 'bold' : 'normal',
            }}
          >
            {item.label}
          </Typography>
        ))}
      </MuiBreadcrumbs>
      {displayActions && <Box>{displayActions}</Box>}
    </Box>
  )
}

export default Breadcrumbs
